import { Bot, Search, Sparkles } from 'lucide-react';

interface TypingIndicatorProps {
  status?: string;
}

const statusConfig: Record<string, { icon: typeof Bot; text: string }> = {
  searching: { icon: Search, text: 'Searching knowledge base...' },
  generating: { icon: Sparkles, text: 'Generating response...' },
  default: { icon: Bot, text: 'Thinking...' },
};

export function TypingIndicator({ status }: TypingIndicatorProps) {
  const config = status && status in statusConfig
    ? statusConfig[status]
    : statusConfig.default;

  const Icon = config.icon;

  return (
    <div className="flex gap-4 animate-fade-in" role="status" aria-live="polite">
      {/* Avatar */}
      <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center bg-gray-100">
        <Bot size={16} className="text-gray-600" />
      </div>

      {/* Content */}
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-sm font-medium text-gray-700">Assistant</span>
        </div>

        <div className="inline-flex items-center gap-2 bg-gray-100 rounded-2xl rounded-tl-md px-4 py-3">
          <Icon size={16} className="text-primary-500 animate-pulse" />
          <span className="text-gray-600 text-sm">{config.text}</span>

          {/* Animated dots */}
          <div className="flex gap-1">
            <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-typing" style={{ animationDelay: '0ms' }} />
            <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-typing" style={{ animationDelay: '200ms' }} />
            <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-typing" style={{ animationDelay: '400ms' }} />
          </div>
        </div>
      </div>
    </div>
  );
}
